import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import IdNoVerification from '../views/IdNoVerification.vue';
import FormData from '../views/FormData.vue';
import FormDataForShare from '../views/FormDataForShare.vue';
import FinishForShare from '../views/FinishForShare.vue';
import Finish from '../views/Finish.vue';
import SingleSignOn from '../views/SingleSignOn.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/idNoVerification',
        name: 'IdNoVerification',
        component: IdNoVerification
    },
    {
        path: '/formData',
        name: 'FormData',
        component: FormData
    },
    {
        path: '/formDataForShare',
        name: 'FormDataForShare',
        component: FormDataForShare
    },
    {
        path: '/finish',
        name: 'Finish',
        component: Finish
    },
    {
        path: '/finishForShare',
        name: 'FinishForShare',
        component: FinishForShare
    },
    {
        path: '/sso',
        name: 'SingleSignOn',
        component: SingleSignOn
    },
    {
        path: '*',
        redirect: '/',
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

export default router;
